// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","disabled":"Button_disabled__PUkNe","submitting":"Button_submitting__BvcJn"};